import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { App as AntdApp, ConfigProvider } from "antd";
import ptBR from "antd/locale/pt_BR";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { AuthProvider } from "@/contexts/AuthContext";
import { ErrorProvider, useError } from "@/contexts/ErrorContext";
import AppRoutes from "@/routes/AppRoutes";
import { setErrorContextCallback, setErrorMessageCallback } from "@/service";
import { antdTheme } from "@/theme/antdTheme";

dayjs.locale("pt-br");

// Liga o estado global de erro (403/assinatura) ao interceptor do axios.
const ErrorContextConnector: React.FC = () => {
  const { setHas403Error, setErrorMessage } = useError();

  useEffect(() => {
    setErrorContextCallback(setHas403Error);
    setErrorMessageCallback(setErrorMessage);
  }, [setHas403Error, setErrorMessage]);

  return null;
};

// Modal.confirm e message estáticos renderizam fora da árvore do React: sem
// isto, eles não recebem o tema nem o idioma do ConfigProvider abaixo.
ConfigProvider.config({
  holderRender: (children) => (
    <ConfigProvider theme={antdTheme} locale={ptBR}>
      {children}
    </ConfigProvider>
  ),
});

const App: React.FC = () => (
  <ConfigProvider theme={antdTheme} locale={ptBR}>
    <AntdApp>
      <ErrorProvider>
        <ErrorContextConnector />
        <AuthProvider>
          <BrowserRouter
            future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
          >
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </ErrorProvider>
    </AntdApp>
  </ConfigProvider>
);

export default App;
